export enum MenuDesktopType {
	FLOATING = 'FLOATING',
	POPUP = 'POPUP',
}
